const lang = {
  uk: {
    lesson: 'Урок',
    taskDescriptions: {
      syllables: 'послухай слова, назви картинки і букви під ними 👂',
      read: 'назви картинки, а потім літери під цими картинками',
      'read-and-point': 'прочитай ребус і вкажи правильний малюнок',
      'key-read-and-point':
        'прочитай за допомогою ключа і вкажи правильний малюнок',
      demo: ''
    },
  },
  en: {
    lesson: 'Lesson',
    taskDescriptions: {
      syllables:
        'listen to the words, name the pictures, and then the letters below them',
      read: 'name the pictures, and then the letters below them',
      'read-and-point':
        'read the rebus and point at the right picture',
      'key-read-and-point':
        'read with the key and point at the right picture',
      demo: ''
    },
  },
};

export default lang[process.env.GATSBY_LOCALE || 'uk'];
